
<div class="card">
    <div class="card-header">
      <h4 class="card-title float-left" id="basic-layout-form">{{'documentIntelligenceRequests.title' | translate}}</h4>
      <div class="clear-float-left"></div>
      <br>

      <app-company-selection-list [ngClass]="companySelectionListClass" [active]="hasSelectCompanyPermission" [hideLabel]="true" [selectCompanyText]="'users.selectCompanyPlaceHolder' | translate"
        (companyChangedEvent)="handleCompanyChanged($event)">
      </app-company-selection-list>

      <!-- <input type='text' class="d-none d-xl-block form-control filter-input" placeholder="{{'documentIntelligenceRequests.filterByDescriptionPlaceHolder' | translate}}" (keyup)='searchFilter($event)' /> -->

    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
        <table [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
          <thead>
            <tr>
              <th *ngFor="let field of fieldCollection" [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
                (click)="sort(field.canSort, field.name)">{{field.displayName | translate}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let documentIntelligenceRequest of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
              <td class="d-none d-sm-table-cell">{{documentIntelligenceRequest.CompanyName}}</td>
              <td class="d-none d-lg-table-cell">{{documentIntelligenceRequest.FileName}}</td>
              <td class="d-none d-sm-table-cell">
                <i
                  class="d-none d-sm-table-cell"
                  [ngClass]="getStatusIcon(documentIntelligenceRequest.Status)"
                  [title]="documentIntelligenceRequest.Status">
                </i>
              </td>   
              <td class="d-none d-sm-table-cell">{{documentIntelligenceRequest.ModelId }}</td>           
              <td class="d-none d-sm-table-cell">{{documentIntelligenceRequest.Provider}}</td>
              <td class="d-none d-sm-table-cell">{{documentIntelligenceRequest.Format}}</td>
            </tr>
          </tbody>
        </table>
        <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize" (pageChange)="pageChanged($event)" id="server"
          previousLabel="{{'pagination.previousLabel' | translate}}" nextLabel="{{'pagination.nextLabel' | translate}}">
        </pagination-controls>
      </div>
    </div>
  </div>
